import { ANEL_OFF, ERRO, TITULO } from './checkoutUi';

export default function HorarioStep({
  horarios = [],
  selecionadoId,
  onSelect,
  assinatura,
  erro,
}) {
  return (
    <div className="flex flex-col gap-2.5 lg:gap-3.5">
      <div className="flex flex-wrap items-baseline gap-x-2.5 gap-y-1">
        <h2 className={TITULO}>
          {assinatura ? 'Horário de preferência' : 'Horário'}
        </h2>
        <span className="text-[11px] text-[#8a94a8] lg:text-xs">
          {assinatura
            ? 'O dia e a hora que você mais pretende frequentar'
            : 'Entrada única'}
        </span>
      </div>

      {erro && <p className={ERRO}>{erro}</p>}

      <div className="grid grid-cols-2 gap-2.5 pt-1 lg:grid-cols-4 lg:gap-3">
        {horarios.map((h) => {
          const ativo = selecionadoId === h.id;
          return (
            <button
              type="button"
              key={h.id}
              disabled={h.esgotado}
              aria-pressed={ativo}
              onClick={() => onSelect(h.id)}
              className={`relative flex flex-col items-center gap-0.5 rounded-[14px] border-0 p-2.5 lg:p-3 ${
                h.esgotado
                  ? 'cursor-not-allowed bg-[#f6f8fb] text-[#8a94a8]'
                  : ativo
                    ? 'cursor-pointer bg-[#ff2368] text-white'
                    : 'cursor-pointer bg-white text-[#0f1729]'
              }`}
              style={{
                boxShadow:
                  ativo && !h.esgotado
                    ? '0 8px 20px rgba(255,35,104,.25)'
                    : ANEL_OFF,
              }}
            >
              <span
                className={`text-[10px] font-bold uppercase ${
                  h.esgotado
                    ? 'text-[#8a94a8]'
                    : ativo
                      ? 'text-white'
                      : 'text-[#ff2368]'
                }`}
              >
                {h.numero} {h.semana}
              </span>
              <span className="text-[17px] font-extrabold tabular-nums lg:text-lg">
                {h.horario}
              </span>
              {h.esgotado && (
                <span className="absolute -top-2 right-2 rounded-full bg-[#8a94a8] px-[7px] py-0.5 text-[8px] font-bold uppercase text-white">
                  Esgotado
                </span>
              )}
              {!h.esgotado && h.ultimasVagas && (
                <span className="absolute -top-2 right-2 rounded-full bg-[#e0306b] px-[7px] py-0.5 text-[8px] font-bold uppercase text-white">
                  Últimas
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
